module.exports = ".error code {\n  display: inline-block; }\n"